import { useBeacon } from "./hooks/useBeacon";

const BEACON_ID = import.meta.env.VITE_HELPSCOUT_API_KEY;

export default function Beacon(): null {
  useBeacon(BEACON_ID);
  return null;
}
